import * as React from "react";
import { useIsoLayoutEffect } from "../../utils/useIsoLayoutEffect.js";
import { visuallyHidden } from "../../utils/visuallyHidden.js";
import { jsx } from "react/jsx-runtime";
import { voiceOver } from "../../utils/platform/screen-reader.js";
import { webkit } from "../../utils/platform/engine.js";
const FocusGuard = /* @__PURE__ */ React.forwardRef(function FocusGuard2(props, ref) {
  const [role, setRole] = React.useState();
  useIsoLayoutEffect(() => {
    if (voiceOver && webkit) {
      setRole("button");
    }
  }, []);
  const restProps = {
    tabIndex: 0,
    // Role is only for VoiceOver
    role
  };
  return /* @__PURE__ */ jsx("span", {
    ...props,
    ref,
    style: visuallyHidden,
    "aria-hidden": role ? void 0 : true,
    ...restProps,
    "data-base-ui-focus-guard": ""
  });
});
if (process.env.NODE_ENV !== "production") FocusGuard.displayName = "FocusGuard";
export {
  FocusGuard
};
//# sourceMappingURL=FocusGuard.js.map
